export default __webpack_public_path__ + "static/media/wanaka.a87e504f.svg";